import React from 'react';
import { money } from '../../utils/region';

// Shared chrome for the workspace panes (owner 2026-10-13): the same tokens the accounting module
// already uses — var(--bg-surface/--border/--border-strong/--text-*/--accent/--radius-md) — so the
// workspace reads as the module it replaces, not as a second product.
export const dmy = (iso: string) => { const p = String(iso || '').split('-'); return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : iso; };
/** Ledger figures arrive as integer satang; the statements' own convention (StatutoryBooks.tsx). */
export const baht = (satang: any) => { const n = Number(satang) || 0; return `${money(Math.abs(n) / 100)}${n < 0 ? ' (–)' : ''}`; };
/** Merchant documents store decimal amounts in their own currency; shown as stored, 2 decimals. */
export const amt = (n: any) => money(Number(n) || 0, 2);

export const btn: React.CSSProperties = {
  padding: '7px 12px', fontSize: 12.5, fontWeight: 700, borderRadius: 'var(--radius-md)',
  border: '1px solid var(--border-strong)', background: 'var(--bg-surface)', color: 'var(--text-primary)', cursor: 'pointer',
  display: 'inline-flex', alignItems: 'center', gap: 6,
};
export const btnPrimary: React.CSSProperties = { ...btn, background: 'var(--accent)', color: '#fff', border: 'none' };
export const card: React.CSSProperties = {
  padding: '13px 15px', border: '1px solid var(--border)', borderRadius: 10, background: 'var(--bg-surface)',
};
export const sectionHead: React.CSSProperties = {
  fontSize: 11, fontWeight: 800, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--text-tertiary)', marginBottom: 7,
};
export const inp: React.CSSProperties = {
  padding: '7px 10px', fontSize: 12.5, borderRadius: 'var(--radius-md)', border: '1px solid var(--border-strong)',
  background: 'var(--bg-surface)', color: 'var(--text-primary)', outline: 'none', boxSizing: 'border-box',
};
export const table: React.CSSProperties = { width: '100%', borderCollapse: 'collapse', fontSize: 12.5 };
export const th: React.CSSProperties = {
  textAlign: 'left', fontSize: 11, fontWeight: 800, letterSpacing: '.04em', textTransform: 'uppercase',
  color: 'var(--text-tertiary)', padding: '7px 9px', borderBottom: '1px solid var(--border-strong)', whiteSpace: 'nowrap',
};
export const td: React.CSSProperties = { padding: '7px 9px', borderBottom: '1px solid var(--border)', color: 'var(--text-primary)', verticalAlign: 'top' };
export const num: React.CSSProperties = { ...td, textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' };
export const pill: React.CSSProperties = { fontSize: 10.5, fontWeight: 800, padding: '1px 8px', borderRadius: 999, whiteSpace: 'nowrap', display: 'inline-block' };
export const pillGrey: React.CSSProperties = { ...pill, color: 'var(--text-tertiary)', background: 'var(--bg-app)', border: '1px solid var(--border)' };
export const pillGreen: React.CSSProperties = { ...pill, color: '#166534', background: '#E8F6EE', border: '1px solid #BBE5CB' };
export const pillAmber: React.CSSProperties = { ...pill, color: '#92400E', background: '#FFFBEB', border: '1px solid #F1C232' };
export const pillRed: React.CSSProperties = { ...pill, color: '#B42318', background: '#FCEBEB', border: '1px solid #F3B9B9' };
export const pillBlue: React.CSSProperties = { ...pill, color: '#1D4ED8', background: '#EFF6FF', border: '1px solid #BFDBFE' };
export const errBox: React.CSSProperties = {
  fontSize: 12.5, color: '#B42318', background: '#FCEBEB', border: '1px solid #F3B9B9', padding: '8px 12px', borderRadius: 8,
};
export const note: React.CSSProperties = { fontSize: 11.5, color: 'var(--text-tertiary)', lineHeight: 1.6 };

/** Open a blob URL in a new tab and let it go later. The revoke is generous on purpose: a large
 *  ledger takes a moment to paint and an early revoke leaves the reader a blank tab (StatutoryBooks). */
export const openBlob = (url: string) => { window.open(url, '_blank'); setTimeout(() => URL.revokeObjectURL(url), 60_000); };
